export default __webpack_public_path__ + "static/media/question9-mobile.b54b6759.png";